import Vue from 'vue';
import VueRouter, { Route, RouteConfig } from 'vue-router';
import HeaderComponent from '../common/layout/Header';
import MainContentComponent from '../common/layout/main-content.component';
import LoginComponent from '@/common/views/login/login.component';
import AppConstants from '@/common/constants/app.constants';

import SettingComponent from '@/common/views/setting/setting.component';
import BreakInductionComponent from '@/tsort/views/sorting/break-induction/break-induction.component';
// IMPORT COMPONENTS
import SingleSortingComponent from '@/tsort/views/sorting/task-sorting/single-sorting/single-sorting.component';
import MultiSortingComponent from '@/tsort/views/sorting/task-sorting/multi-sorting/multi-sorting.component';
import HandSortingComponent from '@/tsort/views/sorting/task-sorting/hand-sorting/hand-sorting.component';
import NoTaskSortingComponent from '@/tsort/views/sorting/no-task-sorting/no-task-sorting.component';
import TopComponent from '@/common/views/top/top.component';
import TopWrapper from '@/common/views/top/top-wrapper';
import ModeSelectionComponent from '@/common/components/mode-selection/mode-selection.component';
import FlashMessage from '@/common/components/flash-message.component';
import ModeSelectionWrapper from '@/common/components/mode-selection/mode-selection-wrapper';
import store from '@/common/store/index';
import HTTPClient from '../common/http-client';
import ErrorCdMsgConstants from '@/common/constants/error-cd-msg.constants';
import HTTPUtils from '@/common/utils/http.util';
import { ScanSystemMenuResponse } from '@/tsort/model/response/scan-system-menu-response.model';
import { WorkTypeSorting } from '@/tsort/enum/work-type-sorting.enum';
import { WorkInstruction } from '@/tsort/enum/work-instruction.enum';
import NoTaskMultiSortingComponent from '@/tsort/views/sorting/no-task-sorting/no-task-multi-sorting.component';
import SortingUtils from '@/common/utils/sorting.util';
import { ScanSettingResponse } from '@/tsort/model/response/scan-setting-response.model';
import { ScanTarget } from '@/common/enum/scan-target.enum';

Vue.use(VueRouter);
Vue.component('app-header', HeaderComponent);
Vue.component('app-main-content', MainContentComponent);
const routes: Array<RouteConfig> = [
  { path: '/', redirect: store.getters['SettingStore/lastScreenUrl'] || AppConstants.PATH_TO_TOP_PAGE },
  {
    path: AppConstants.LOGIN_ROUTER_PATH,
    name: AppConstants.NAME_LOGIN_PAGE,
    component: LoginComponent
  },
  {
    path: '/top',
    component: TopWrapper,
    meta: { hideBreadcrumb: true },
    children: [
      {
        path: '',
        name: 'TOP',
        component: TopComponent,
        meta: { hideBreadcrumb: true, icon: 'icon-3d-sorter-svg' }
      },
      {
        path: 'break-induction',
        name: AppConstants.NAME_BREAK_INDUCTION_PAGE,
        component: BreakInductionComponent,
        meta: {
          hideBreadcrumb: true,
          icon: 'icon-break-induction-svg',
          parentText1: AppConstants.PRODUCT_SORTING_BREADCRUMB_TEXT
        }
      },
      {
        path: 'setting',
        component: MainContentComponent,
        meta: {
          icon: 'icon-setting-svg',
          parentText2: '選択後に成功メッセージが表示されたら保存完了です。',
          parentText1: '設定'
        },
        children: [
          {
            path: '',
            name: 'Setting',
            component: SettingComponent,
            meta: { breadCrumb: '', icon: 'icon-setting-svg' }
          }
        ]
      },
      {
        path: AppConstants.PATH_TO_MODE_SELECTION_PAGE_T_SORT,
        component: ModeSelectionWrapper,
        meta: {
          breadCrumb: 'TOP',
          parentText1: 't-Sortで商品仕分け',
          parentText2: 't-Sort Sorting',
          icon: 'icon-parallel-sorting-svg'
        },
        children: [
          {
            path: 'mode-selection',
            component: MainContentComponent,
            meta: {
              excludedFromBreadcrumb: true
            },
            children: [
              {
                path: '',
                name: 'Model Selection',
                component: ModeSelectionComponent,
                meta: {
                  breadCrumb: 't-Sort Sorting',
                  icon: 'icon-parallel-sorting-svg',
                  parentText1: AppConstants.PRODUCT_SORTING_BREADCRUMB_TEXT
                }
              },
              {
                path: 'single-sort',
                name: AppConstants.NAME_SINGLE_SORTING_PAGE,
                component: SingleSortingComponent,
                meta: {
                  breadCrumb: 't-Sort Sorting',
                  icon: 'icon-parallel-sorting-svg',
                  parentText1: AppConstants.PRODUCT_SORTING_BREADCRUMB_TEXT,
                  workType: WorkTypeSorting.SINGLE_SORTING,
                  workInstruction: WorkInstruction.PARALLEL_SORTING,
                  scanSetting: store.getters['SortStore/scanSetting'] as ScanSettingResponse
                }
              },
              {
                path: 'multi-sort',
                name: AppConstants.NAME_MULTI_SORTING_PAGE,
                component: MultiSortingComponent,
                meta: {
                  breadCrumb: 't-Sort Sorting',
                  icon: 'icon-parallel-sorting-svg',
                  parentText1: AppConstants.PRODUCT_SORTING_BREADCRUMB_TEXT,
                  workType: WorkTypeSorting.MULTI_SORTING,
                  workInstruction: WorkInstruction.PARALLEL_SORTING
                }
              },
              {
                path: 'hand-sort',
                name: AppConstants.NAME_HAND_SORTING_PAGE,
                component: HandSortingComponent,
                meta: {
                  breadCrumb: 't-Sort Sorting',
                  icon: 'icon-parallel-sorting-svg',
                  parentText1: AppConstants.PRODUCT_SORTING_BREADCRUMB_TEXT,
                  workType: WorkTypeSorting.MANUAL_SORTING,
                  workInstruction: WorkInstruction.PARALLEL_SORTING
                }
              },
              {
                path: 'no-task-single-sort',
                name: AppConstants.NAME_NO_TASK_SINGLE_SORTING_PAGE,
                component: NoTaskSortingComponent,
                meta: {
                  breadCrumb: 't-Sort Sorting',
                  icon: 'icon-parallel-sorting-svg',
                  parentText1: AppConstants.PRODUCT_SORTING_BREADCRUMB_TEXT,
                  workType: WorkTypeSorting.SINGLE_SORTING,
                  workInstruction: WorkInstruction.NO_WORK_INSTRUCTION
                }
              },
              {
                path: 'no-task-multi-sort',
                name: AppConstants.NAME_NO_TASK_MULTI_SORTING_PAGE,
                component: NoTaskMultiSortingComponent,
                meta: {
                  breadCrumb: 't-Sort Sorting',
                  icon: 'icon-parallel-sorting-svg',
                  parentText1: AppConstants.PRODUCT_SORTING_BREADCRUMB_TEXT,
                  workType: WorkTypeSorting.MULTI_SORTING,
                  workInstruction: WorkInstruction.NO_WORK_INSTRUCTION
                }
              }
            ]
          }
        ]
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
});

// リストリンクスキャンスクリーン
const SCAN_SCREEN_NAMES = [
  AppConstants.NAME_SINGLE_SORTING_PAGE,
  AppConstants.NAME_MULTI_SORTING_PAGE,
  AppConstants.NAME_NO_TASK_SINGLE_SORTING_PAGE,
  AppConstants.NAME_NO_TASK_MULTI_SORTING_PAGE,
  AppConstants.NAME_HAND_SORTING_PAGE
];

// 必要なリンク誘導画面
const SCAN_SCREEN_REQUIRED_LINK_INDUCTION_NAMES = [
  AppConstants.NAME_SINGLE_SORTING_PAGE,
  AppConstants.NAME_MULTI_SORTING_PAGE,
  AppConstants.NAME_NO_TASK_SINGLE_SORTING_PAGE,
  AppConstants.NAME_NO_TASK_MULTI_SORTING_PAGE
];

// オーダー番号モード
const ORDER_NO_MODE = 1;

/**
 * スキャンシステムメニューを取得する。
 *
 * @param {number} targetWorkInstruction 対象作業指示
 * @returns {scanSystemMenu | []}
 */
const getScanSystemMenu = async (targetWorkInstruction: number) => {
  // 在のタスクタイプのソートを取得する
  const taskTypeSorting = store.getters['SortStore/taskTypeSorting'];
  const workInstruction = SortingUtils.workInstruction;

  // 対象ページの作業指示がソートストアの作業手順と異なる場合、空の配列を返します
  if (workInstruction !== targetWorkInstruction) {
    return [];
  }

  // API実行
  const axiosResponse = await HTTPClient.getInstance().HTTP.get<Array<ScanSystemMenuResponse>>(
    '/func/get-scan-system-field-v2'
  );
  const dataResponse = HTTPClient.convertAxiosResponseToResponse(axiosResponse);
  const scanSystemMenu = SortingUtils.filterListByCondition(dataResponse, {
    taskType: taskTypeSorting,
    displayFlag: AppConstants.DISPLAY_FLAG_ON,
    workInstruction: workInstruction
  });
  return scanSystemMenu;
};

/**
 * スキャン設定を更新する。
 *
 * @param scanSetting スキャン設定
 * @param delayUpdateFlag 更新を遅らせるかどうかのフラグ
 */
const updateScanSetting = (scanSetting: ScanSettingResponse, delayUpdateFlag = false) => {
  if (!scanSetting) {
    return;
  }
  if (delayUpdateFlag) {
    setTimeout(() => {
      store.dispatch('SortStore/updateScanSetting', scanSetting, { root: true });
    }, 350);
  } else {
    store.dispatch('SortStore/updateScanSetting', scanSetting, { root: true });
  }
};

/**
 * スキャン設定を取得する。
 *
 * @param isRedirectNotFromLoginPage がtrueの場合、スキャン設定を取得します
 * @returns スキャン設定データの応答
 */
const getScanSetting = async (isRedirectNotFromLoginPage: boolean) => {
  if (isRedirectNotFromLoginPage) {
    const axiosResponse = await HTTPClient.getInstance().HTTP.get<ScanSettingResponse>('func/get-scan-setting');
    const scanSetting = HTTPClient.convertAxiosResponseToResponse(axiosResponse);
    return scanSetting;
  }
  return store.getters['SortStore/currentScanSetting'];
};

/**
 * RFIDモードのスキャン対象を取得する関数です。
 *
 * @returns 現在のRFIDモードのスキャン対象
 */
const getRfidModeScanTarget = () => {
  return store.getters['SortStore/rfidModeScanTarget'];
};

/**
 * 注文番号モードのスキャン対象を取得する関数です。
 *
 * @returns 順序番号モード スキャン対象
 */
const getOrderNumberModeScanTarget = () => {
  return store.getters['SortStore/orderNumberModeScanTarget'];
};

/**
 * スクリーンの復元情報を取得します。
 */
const getRestoreScreen = () => {
  return store.getters['SettingStore/restoreScreen'];
};

/**
 * RFIDモードのスキャンターゲットを更新します。
 *
 * @param modeTarget 更新するRFIDモードのスキャンターゲット
 */
const updateRFIDModeScanTarget = (modeTarget: ScanTarget) => {
  store.dispatch('SortStore/updateRFIDModeScanTarget', modeTarget, { root: true });
};

/**
 * 注文番号モードのスキャンターゲットを更新します。
 *
 * @param modeTarget 更新する注文番号モードのスキャンターゲット
 */
const updateOrderNumberModeScanTarget = (modeTarget: ScanTarget) => {
  store.dispatch('SortStore/updateOrderNumberModeScanTarget', modeTarget, { root: true });
};

/**
 * シングルソートページのデータを処理します。
 *
 * @param currentScanSetting 現在のスキャン設定
 * @param oldScanSetting 古いスキャン設定
 */
const checkToUpdateSingleSortScreenData = (
  currentScanSetting: ScanSettingResponse,
  oldScanSetting: ScanSettingResponse
) => {
  const currentRfidMode = currentScanSetting?.rfidMode;
  const currentOrderNumberMode = currentScanSetting?.orderNumberScanUse;

  const oldRfidMode = oldScanSetting?.rfidMode;
  const oldOrderNumberMode = oldScanSetting?.orderNumberScanUse;

  const rfidModeScanTarget = getRfidModeScanTarget();
  const orderNumberModeScanTarget = getOrderNumberModeScanTarget();

  if (
    !oldRfidMode &&
    currentRfidMode &&
    rfidModeScanTarget !== ScanTarget.BARCODE &&
    (oldOrderNumberMode !== ORDER_NO_MODE || orderNumberModeScanTarget === ScanTarget.BARCODE)
  ) {
    updateRFIDModeScanTarget(ScanTarget.BARCODE);
  } else if (
    oldOrderNumberMode !== ORDER_NO_MODE &&
    currentOrderNumberMode === ORDER_NO_MODE &&
    orderNumberModeScanTarget !== ScanTarget.BARCODE &&
    (!oldRfidMode || rfidModeScanTarget === ScanTarget.BARCODE)
  ) {
    updateOrderNumberModeScanTarget(ScanTarget.BARCODE);
  }
};

/**
 * リダイレクトを停止するかどうかを判定します。
 *
 * @param to 遷移先のルートオブジェクト
 * @param from 現在のルートオブジェクト
 * @returns リダイレクトを停止する場合は true、それ以外の場合は false
 */
const isRedirectStopped = (to: Route, from: Route) => {
  const isInductionBreaking = store.getters['SettingStore/isInductionBreaking'];
  const isRedirectBlockedToBreakInductionPage =
    to.name === AppConstants.NAME_BREAK_INDUCTION_PAGE && !isInductionBreaking;
  const isRedirectBlockedFromBreakInductionPage =
    to.name !== AppConstants.NAME_LOGIN_PAGE &&
    from.name === AppConstants.NAME_BREAK_INDUCTION_PAGE &&
    isInductionBreaking;
  return isRedirectBlockedToBreakInductionPage || isRedirectBlockedFromBreakInductionPage;
};

/**
 * スクリーンの復元情報を更新します。
 *
 * @param to 遷移先のルートオブジェクト
 * @param from 遷移元のルートオブジェクト
 */
const updateRestoreScreen = (to: Route, from: Route) => {
  if (from.name && from.name !== AppConstants.NAME_LOGIN_PAGE) {
    const isFromBreakInductionPage = from.name === AppConstants.NAME_BREAK_INDUCTION_PAGE;
    const fromName = isFromBreakInductionPage ? getRestoreScreen() || AppConstants.NAME_TOP_PAGE : from.name;
    const infoRestore = {
      userId: store.getters['Auth/userId'],
      externalDeviceId: store.getters['SettingStore/externalDeviceId'],
      inductionId: store.getters['SettingStore/inductionId'],
      lastAccessedScreen:
        to.name === AppConstants.NAME_LOGIN_PAGE || to.name === AppConstants.NAME_BREAK_INDUCTION_PAGE
          ? fromName
          : to.name
    };
    store.dispatch('SettingStore/updateRestoreScreen', infoRestore, { root: true });
  }
};

/**
 * スキャンシステムメニューのデータを更新します。
 *
 * @param to 遷移先のルートオブジェクト
 * @param scanSystemMenuGoToTargetPage 遷移先ページに表示するスキャンシステムメニュー
 * @param scanSystemMenu 現在のスキャンシステムメニュー
 * @param targetWorkType 対象作業タイプ
 */
const updateDataOfScanScreenTarget = (
  to: Route,
  scanSystemMenuGoToTargetPage: ScanSystemMenuResponse[],
  scanSystemMenu: ScanSystemMenuResponse[],
  targetWorkType: number
) => {
  // シングルソートページまたはマルチソートページでの切り替えボタンの表示を処理する
  store.commit('setSwitchingBtnMode', false);
  if (to?.name !== AppConstants.NAME_HAND_SORTING_PAGE) {
    const scanSystemMenuToShowSwitchingBtn = scanSystemMenu.filter(
      (item) => item.workType !== WorkTypeSorting.MANUAL_SORTING
    );
    // scanSystemMenuToShowSwitchingBtnの長さが2であれば、対象のタスクタイプはシングルおよびマルチソートの両方を持っていることを意味し、切り替えボタンが表示されます
    if (scanSystemMenuToShowSwitchingBtn.length === 2) {
      // setSwitchingBtnModeがtrueの場合、切替ボタンを表示します
      store.commit('setSwitchingBtnMode', true);
    }
  }
  // ストレージ内のデータを更新する
  store.dispatch('SortStore/updateScanSystemMenu', scanSystemMenuGoToTargetPage[0], { root: true });
  store.dispatch('SortStore/updateWorkTypeSorting', targetWorkType, { root: true });
};

// Handle Unauthorized Access
router.beforeEach(async (to, from, next) => {
  // Check work mode before target other page, if it is null set work mode 0
  if (to.path.indexOf(AppConstants.PATH_TOP_FUJI) !== -1) {
    localStorage.setItem(AppConstants.STORAGE_WORK_MODE, AppConstants.WORK_MODE_OPS.toString());
  } else if (to.path.indexOf(AppConstants.PATH_TO_MODE_SELECTION_PAGE_T_SORT) !== -1) {
    localStorage.setItem(AppConstants.STORAGE_WORK_MODE, AppConstants.WORK_MODE_T_SORT.toString());
  }

  // リダイレクトを停止する
  if (isRedirectStopped(to, from)) {
    return next(false);
  }

  // 現在の画面復元オブジェクトをlocalStorageに追加します
  updateRestoreScreen(to, from);

  const publicPages = [AppConstants.LOGIN_ROUTER_PATH];
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  const authMode = config && config['AUTH_MODE'];
  if (authMode) {
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem(AppConstants.STORAGE_TOKEN);
    // trying to access a restricted page + not logged in?
    if (authRequired && !loggedIn) {
      // => redirect to login page
      return next(AppConstants.LOGIN_ROUTER_PATH);
    }
  } else if (to.path === AppConstants.LOGIN_ROUTER_PATH) {
    return next(AppConstants.PATH_TO_TOP_PAGE);
  }
  if (FlashMessage.isCreated() && store.getters.getNetworkConnectionMode) {
    // 表示されているエラーメッセージをすべてクリアする
    FlashMessage.getInstance().hideAllMessages();
  }

  // 伝票スキャン
  const oldScanSetting = store.getters['SortStore/scanSetting'];

  // スキャン画面にアクセスし、changeWorkTypeModeがfalseの場合、ストレージ内のデータを更新するかトップページに戻るかを条件を確認します
  if (SCAN_SCREEN_NAMES.includes(to?.name || '') && !store.getters.getChangeWorkTypeMode) {
    // 情報のスキャンを取得して処理する
    const targetWorkType = to?.meta?.workType;
    const targetWorkInstruction = to?.meta?.workInstruction;
    const scanSystemMenu = await getScanSystemMenu(targetWorkInstruction);
    const scanSystemMenuGoToTargetPage = scanSystemMenu.filter((item) => item.workType === targetWorkType);

    // スキャンシステムメニューが空の場合、トップページに移動し、ソートストアを更新して
    if (scanSystemMenuGoToTargetPage.length === 0) {
      // ストレージ内のデータを更新する
      store.dispatch('SortStore/resetTaskTypeInfo', { root: true });
      return next(AppConstants.PATH_TO_TOP_PAGE);
    }

    // スキャンシステムメニューが1つの場合、ストレージ内のデータを更新する
    updateDataOfScanScreenTarget(to, scanSystemMenuGoToTargetPage, scanSystemMenu, targetWorkType);

    const currentScanSetting = await getScanSetting(from?.name !== AppConstants.NAME_LOGIN_PAGE).catch(() => {
      return;
    });
    updateScanSetting(currentScanSetting);
    if (to?.name === AppConstants.NAME_SINGLE_SORTING_PAGE) {
      if (from?.name === AppConstants.NAME_MODE_SELECTION_PAGE) {
        if (currentScanSetting?.rfidMode && getRfidModeScanTarget() === null) {
          updateRFIDModeScanTarget(ScanTarget.RFID);
        }
      } else {
        // rfidModeScanTargetの値が現在バーコードに設定されているかどうかを確認する条件を追加します。設定されていない場合は、処理を続行します
        if (getRfidModeScanTarget() !== ScanTarget.BARCODE) {
          // シングルRFID画面が表示されている間にRFIDモードを非アクティブに切り替えます。シングルソートページをリロードするか、ログアウトして再度ログインすると、トップ画面にリダイレクトされます
          if (!currentScanSetting?.rfidMode && oldScanSetting?.rfidMode) {
            return next(AppConstants.PATH_TO_TOP_PAGE);
          }

          // RFIDモードがアクティブに切り替わり、単一バーコードが開かれている場合、スキャンされたアイテムの選択状態はバーコードに設定されます
          if (
            currentScanSetting?.rfidMode &&
            !oldScanSetting?.rfidMode &&
            (oldScanSetting?.orderNumberScanUse !== ORDER_NO_MODE ||
              getOrderNumberModeScanTarget() === ScanTarget.BARCODE)
          ) {
            updateRFIDModeScanTarget(ScanTarget.BARCODE);
          }
        }

        // 伝票モード時のモードをチェック
        if (getOrderNumberModeScanTarget() !== ScanTarget.BARCODE) {
          // バーコードに設定されていない場合、伝票モードを非アクティブに切り替える
          if (
            currentScanSetting?.orderNumberScanUse !== ORDER_NO_MODE &&
            oldScanSetting?.orderNumberScanUse === ORDER_NO_MODE
          ) {
            // 単一投入ページをリロードしたとき、トップ画面にリダイレクト
            return next(AppConstants.PATH_TO_TOP_PAGE);
          }

          // 伝票モードが有効かつ単一投入バーコードが開かれている場合
          if (
            currentScanSetting?.orderNumberScanUse === ORDER_NO_MODE &&
            oldScanSetting?.orderNumberScanUse !== ORDER_NO_MODE
          ) {
            // 次回以降の伝票モード有効時はバーコードとなる
            updateOrderNumberModeScanTarget(ScanTarget.BARCODE);
          }
        }
      }
    }
  } else if (to?.name !== AppConstants.NAME_LOGIN_PAGE) {
    // ログインページ以外の場合、スキャン設定を取得して処理する
    const currentScanSetting = (await getScanSetting(from?.name !== AppConstants.NAME_LOGIN_PAGE).catch(() => {
      return;
    })) as ScanSettingResponse;
    if (from?.name === AppConstants.NAME_SINGLE_SORTING_PAGE) {
      checkToUpdateSingleSortScreenData(currentScanSetting, oldScanSetting);
    } else if (
      from?.name === AppConstants.NAME_MULTI_SORTING_PAGE &&
      currentScanSetting?.rfidMode &&
      getRfidModeScanTarget === null
    ) {
      updateRFIDModeScanTarget(ScanTarget.RFID);
    }

    if (
      to?.name !== AppConstants.NAME_BREAK_INDUCTION_PAGE ||
      (from?.name && from?.name !== AppConstants.NAME_LOGIN_PAGE)
    ) {
      // ソート切り替えボタンでマルチソート画面にリダイレクトされた場合、データの更新を遅延させる必要があります
      const delayUpdateFlag = store.getters.getChangeWorkTypeMode && to?.name === AppConstants.NAME_MULTI_SORTING_PAGE;
      updateScanSetting(currentScanSetting, delayUpdateFlag);
    } else if (!currentScanSetting?.inductionProcessingMode) {
      store.dispatch('SettingStore/updateInductionBreakingFlag', false, { root: true });
      return next({ name: getRestoreScreen() || AppConstants.NAME_TOP_PAGE });
    }
  }

  // 誘導が必要なページにリンク誘導がない場合は設定画面へ
  if (
    SCAN_SCREEN_REQUIRED_LINK_INDUCTION_NAMES.includes(to?.name || '') &&
    from?.name !== AppConstants.NAME_MODE_SELECTION_PAGE &&
    from?.name !== AppConstants.NAME_LOGIN_PAGE &&
    from?.name !== AppConstants.NAME_BREAK_INDUCTION_PAGE
  ) {
    let isExpiredTokenError = false;
    // リンク誘導を確認する
    const dataRes = await HTTPClient.getInstance()
      .HTTP_WITHOUT_MSG.get('/func/get-link-induction', {
        params: {
          externalDeviceId: store.getters['SettingStore/externalDeviceId'],
          externalDeviceType: AppConstants.DEVICE_TYPE
        }
      })
      .catch((_err) => {
        isExpiredTokenError = HTTPUtils.isExpiredTokenError(_err);
        if (!isExpiredTokenError) {
          FlashMessage.getInstance().showErrorMsgWithErrorCode(
            ErrorCdMsgConstants.FUNC_WITHOUT_SELECTING_INDUCTION_ON_REQUIRED_SCREEN_ERR_CD,
            ErrorCdMsgConstants.FUNC_WITHOUT_SELECTING_INDUCTION_ON_REQUIRED_SCREEN_ERR_MSG,
            true
          );
        }
      });
    // リンク案内がない場合は設定画面へ
    if (!isExpiredTokenError && !dataRes?.data?.mstInduction) {
      FlashMessage.getInstance().showErrorMsgWithErrorCode(
        ErrorCdMsgConstants.FUNC_WITHOUT_SELECTING_INDUCTION_ON_REQUIRED_SCREEN_ERR_CD,
        ErrorCdMsgConstants.FUNC_WITHOUT_SELECTING_INDUCTION_ON_REQUIRED_SCREEN_ERR_MSG,
        true
      );
      return next('/top/setting');
    }
  }
  // => go to target page
  next();
  // 前のページにリダイレクト
  store.dispatch('SettingStore/updateLastScreenUrl', to?.fullPath, { root: true });
});

export default router;
